var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSodarDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11443 3.0769C1.79639 3.0769 1.53857 3.33763 1.53857 3.65925C1.53857 3.72357 1.59014 3.77572 1.65375 3.77572H1.76892L4.41786 12.7438H12.1919L14.7833 3.77572H14.8985C14.9621 3.77572 15.0136 3.72357 15.0136 3.65925C15.0136 3.33763 14.7558 3.0769 14.4378 3.0769H2.11443Z",
    fill: "#1E2447"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46826 12.7438H12.3775V15.6731H4.46826V12.7438Z",
    fill: "#1E2447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32424 10.3303H4.31826V10.4803V15.6732V15.8232H4.46826H12.3775H12.5275V15.6732V10.4803V10.3303H12.5216C12.4052 8.31677 10.6042 6.73513 8.4229 6.73513C6.24162 6.73513 4.4406 8.31677 4.32424 10.3303ZM11.8782 10.4883L11.8786 10.5128V15.1808H4.9672V10.5128L4.96761 10.4883C4.99569 8.79525 6.50159 7.37753 8.4229 7.37753C10.3442 7.37753 11.8501 8.79525 11.8782 10.4883Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88184 15.6488C3.88184 15.5814 3.93584 15.5267 4.00246 15.5267H5.63945H5.81177H10.7572H10.9123H12.825C12.9011 15.5267 12.9629 15.5814 12.9629 15.6488V16.8694C12.9629 16.9368 12.9011 16.9914 12.825 16.9914H10.7572C10.6811 16.9914 10.6194 16.9368 10.6194 16.8694V16.4055H5.93239V16.8694C5.93239 16.9368 5.87839 16.9914 5.81177 16.9914H4.00246C3.93584 16.9914 3.88184 16.9368 3.88184 16.8694V15.6488Z",
    fill: "#1E2447"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0957 8.57862C13.0636 8.52306 13.0826 8.45203 13.1382 8.41995L13.5406 8.18764C13.5961 8.15557 13.6672 8.1746 13.6992 8.23016L18.4034 16.3781C18.4355 16.4337 18.4165 16.5047 18.3609 16.5368L17.9586 16.7691C17.903 16.8012 17.832 16.7821 17.7999 16.7266L13.0957 8.57862Z",
    fill: "#1E2447"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSodarDark);
export default __webpack_public_path__ + "static/media/SodarDark.8aea6c4c.svg";
export { ForwardRef as ReactComponent };